import { useTranslation } from 'react-i18next';
import { LineText } from '@common/components/fragments/LineText';
import AuditsExportsCockpitCityExport from '@/app/spraypaint/audits/exports/AuditsExportsCockpitCityExport';
import {
  SubformComponent,
  SubCardFieldsComponent,
  SubModule,
} from '@/modules/admin/audits/components/submodules/types';

export const jsonApiType = AuditsExportsCockpitCityExport.jsonapiType;

export type Values = Record<string, never>;

export const defaultValues: Values = {};

function createExportStrategy(): AuditsExportsCockpitCityExport {
  return new AuditsExportsCockpitCityExport();
}

export const FormComponent: SubformComponent = () => null;

export const CardFieldsComponent: SubCardFieldsComponent<
  AuditsExportsCockpitCityExport
> = () => {
  const { t } = useTranslation();

  return (
    <LineText
      label={t('activerecord.attributes.audits/export.export_strategy', {
        ns: 'rails',
      })}
      value={t('activerecord.models.audits/exports/cockpit_city_exports', {
        ns: 'rails',
      })}
    />
  );
};

export const AuditsExportsCockpitCityExportSubmodule: SubModule<
  Values,
  AuditsExportsCockpitCityExport
> = {
  jsonApiType,
  defaultValues,
  FormComponent,
  CardFieldsComponent,
  createExportStrategy,
};
